import _ from 'lodash'
export default function DirtyFunction (array, data) {
  
  data = data[data.length-1]
  let arrayN = { 
  'asegurador': array.asegurador,
  'aseguradorId': array.aseguradorId,
  'prestacion': array.prestacion,
  'prestacionId': array.prestacionId,
  'programa': array.programa,
  'programaId': array.programaId,
  'diastoleSentado': array.presionSentadoBaja,
  'diastoleParado': array.presionParadoBaja,
  'sistoleSentado': array.presionSentadoAlta,
  'sistoleParado': array.presionParadoAlta,
  'perimetroAbdominal': array.pabdominal,
  'balanceNeuroMuscularIzquierdo': array.balanceNeuroIMuscular,
  'balanceNeuroMuscularDerecho': array.balanceNeuroDMuscular,
  'gripi': array.gripi,
  'gripd': array.gripd,
  'itbIzquierdo': array.itbi,
  'itbDerecho': array.itbd,
  'imc': array.imc,
  'vop': array.vop,
  'balanceNeuroMuscularT': array.balanceNeuroIMuscular,
  'notas': array.notasText,
  'frecuencia': array.frecuencia,
  'tiempoCincoM': array.tiempoCincoM,
  'mets': array.medicalData.mets,
  'depresion': array.medicalData.depresion,
  'satisfaccion': array.medicalData.satisfaccion,
  'feliz': array.medicalData.feliz,
  'preocupacion': array.medicalData.preocupacion,
  'decaido': array.medicalData.decaido,
  'gender': array.patientGender,
  'peso': array.peso,
  'altura': array.altura,
  'fechaNacimiento': array.patientBirthday,
  'fuma': array.medicalData.fuma,
  'movilidad': array.medicalData.movilidad,
  'cuidadoPersonal': array.medicalData.cuidadoPersonal,
  'actividadesCotidianas': array.medicalData.actividadesCotidianas,
  'dolor': array.medicalData.dolor,
  'ansiedad': array.medicalData.ansiedad,
  'paciente': array.patientId,
  'salud': array.health,
  'temperatura': array.temperatura,
  'grasaCorporal': array.grasaCorporal
  }

  let array_ =  _.pickBy(arrayN, (value, key) => { return (data[key] !== value) })
  return array_
}



// WEBPACK FOOTER //
// ./src/components/Health/DirtyFunction.js